Vue = require 'vue'

Vue.directive 'focus', {
  bind: (el, binding, vnode)->
    console.log 'Focus', binding.arg
    if binding.value
      Vue.nextTick -> el.focus()

}
